<template>
  <div id="app">
    <div class="loader_bx" :class="{ 'active': $store.state.loader }">
      <div class="spinner">
        <span class="nd_loader">
          <svg width="50" height="40" viewBox="0 0 88 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd"
      d="M33.6894 3.15366C29.7285 1.05437 25.1176 0 19.8522 0H0V21.0526H45.7955C45.3675 17.7559 44.3824 14.7142 42.8399 11.9811C40.7053 8.19858 37.6551 5.25768 33.6942 3.14894L33.6894 3.15366ZM45.646 29.8246H0V50H19.8522C25.0702 50 29.6573 48.9267 33.623 46.7707C37.584 44.6194 40.6436 41.6548 42.802 37.8676C44.2062 35.4067 45.1546 32.7257 45.646 29.8246ZM60.0736 29.8246H74.02V50H60.0736V29.8246ZM74.02 21.0526H60.0736V11.0638H46.0372V0H87.3971V11.0638H74.02V21.0526Z"
      fill="white"/>
</svg>

        </span>
        <div class="spinner_one"></div>
        <div class="spinner_two"></div>
        <div class="spinner_three"></div>
        <div class="spinner_fore"></div>
        <div class="spinner_five"></div>
      </div>
    </div>


    <router-view/>


    <notifications
        class="az_notification"
        group="simple"
        position="top right"
        :duration="5000"
    ></notifications>


    <vue-headful
        v-bind="{
					'lang': $i18n.locale,
					...$store.state.metaData
				}"
    ></vue-headful>
  </div>
</template>

<script>
import TokenService, {token} from './services/TokenService';
import {IDENTITY_SERVICE, MODE} from "@/defaults";
import {UseLanguageStorage} from "@/services/LanguageStorage";

const {setLang} = UseLanguageStorage()


export default {
  watch: {
    "$i18n.locale"(lang) {
      // this.calendar.setOption('locale', lang)
    },
    '$route': {
      handler(to, from) {
        this.$store.state.metaData.title = to.meta.title ? to.meta.title() : 'DTM';
        this.$store.state.metaData.description = to.meta.description ? to.meta.description() : 'Test description';
        this.$store.state.metaData.keywords = to.meta.keywords ? to.meta.keywords() : 'Test keyword';
      },
      immediate: true
    }
  },
  mounted() {
    if (window) {
      window.$loadDtHeader({
        currentLang: this.$i18n.locale,
        position: 'fixed',
        activeModule: 'kpi',
        enableProfileIcon: true,
        mode: MODE,
        enableLanguageSwitcher: true,
        onLogout: () => {
          token.Logout()
          token.Remove()
        },
        onSelectLanguage: (lang) => {
          this.$i18n.locale = lang;
          setLang(lang)
          localStorage.setItem('lang', lang);

          this.$api
              .post('/users/change/language', {
                langCode: lang,
              });
        },
        // onClickProfileIcon:() => {
        //   // $('[data-custom-switch-body]').addClass('active');
        //   if(this.$store.state.profileActiveClass === 'active') {
        //     this.$store.state.profileActiveClass = ''
        //   } else {
        //     this.$store.state.profileActiveClass = 'active'
        //   }
        //
        // }
      })
    }
  },
  created() {
    if (TokenService.token.Get()) {

      // this.$store.state.refreshTokenIntervalId = setInterval(() => {
      // 	if (+new Date() / 1000 > TokenService.expireTime.Get() - 60)
      // 	{
      // 		this.RefreshToken();
      // 	}
      //
      // }, 1000);


      this.GetProfileInfo();
    }
  },
  methods: {
    RefreshToken() {
      this.$api
          .post('auth/refresh-token', {
            'refreshToken': TokenService.refreshToken.Get(),
          })
          .then(response => {
            TokenService.token.Save(response.data.data.sessionToken);
            TokenService.refreshToken.Save(response.data.data.refreshToken);
            TokenService.expireTime.Save((+new Date() / 1000) + response.data.data.expiresIn);
          });
    },
    GetProfileInfo() {
      this.$api
          .get('users/me')
          .then(response => {
            this.$store.state.userProfile = response.data.data;
            let sortedPermissions = [];
            response.data.data.roles.forEach(role => {
              role.permissions.forEach(perm => {
                if (sortedPermissions.findIndex(x => x.codeName === perm.codeName) < 0) {
                  sortedPermissions.push(perm);
                }
              });
            });
            this.$store.state.permissionList = sortedPermissions;
            if(this.$route.fullPath==='/forbidden'){
              this.$router.push('/main')
            }
          }).catch((e) => {
        if (e.response && e.response.status === 403) {
          this.$router.push("/forbidden")
        } else if (e.response.status === 401) {
          token.Remove()
          if (!window.location.href.includes('is_dev')) {
            window.location.href = IDENTITY_SERVICE
          }
        }
      });
    },
  }
};
</script>
